/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as KontakRouteImport } from './routes/kontak'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShopIndexRouteImport } from './routes/shop/index'
import { Route as PraCetakIndexRouteImport } from './routes/pra-cetak/index'
import { Route as PenerbitanIndexRouteImport } from './routes/penerbitan/index'
import { Route as KonversiKtiIndexRouteImport } from './routes/konversi-kti/index'
import { Route as JasaCetakIndexRouteImport } from './routes/jasa-cetak/index'
import { Route as ArtikelIndexRouteImport } from './routes/artikel/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ShopSlugRouteImport } from './routes/shop/$slug'
import { Route as ArtikelSlugRouteImport } from './routes/artikel/$slug'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminProductsIndexRouteImport } from './routes/admin/products/index'
import { Route as AdminProductsCreateRouteImport } from './routes/admin/products/create'
import { Route as AdminProductsIdEditRouteImport } from './routes/admin/products/$id.edit'

const KontakRoute = KontakRouteImport.update({
  id: '/kontak',
  path: '/kontak',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopIndexRoute = ShopIndexRouteImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => rootRouteImport,
} as any)
const PraCetakIndexRoute = PraCetakIndexRouteImport.update({
  id: '/pra-cetak/',
  path: '/pra-cetak/',
  getParentRoute: () => rootRouteImport,
} as any)
const PenerbitanIndexRoute = PenerbitanIndexRouteImport.update({
  id: '/penerbitan/',
  path: '/penerbitan/',
  getParentRoute: () => rootRouteImport,
} as any)
const KonversiKtiIndexRoute = KonversiKtiIndexRouteImport.update({
  id: '/konversi-kti/',
  path: '/konversi-kti/',
  getParentRoute: () => rootRouteImport,
} as any)
const JasaCetakIndexRoute = JasaCetakIndexRouteImport.update({
  id: '/jasa-cetak/',
  path: '/jasa-cetak/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtikelIndexRoute = ArtikelIndexRouteImport.update({
  id: '/artikel/',
  path: '/artikel/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopSlugRoute = ShopSlugRouteImport.update({
  id: '/shop/$slug',
  path: '/shop/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtikelSlugRoute = ArtikelSlugRouteImport.update({
  id: '/artikel/$slug',
  path: '/artikel/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
  id: '/admin/products/',
  path: '/admin/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductsCreateRoute = AdminProductsCreateRouteImport.update({
  id: '/admin/products/create',
  path: '/admin/products/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductsIdEditRoute = AdminProductsIdEditRouteImport.update({
  id: '/admin/products/$id/edit',
  path: '/admin/products/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/kontak': typeof KontakRoute
  '/admin/login': typeof AdminLoginRoute
  '/artikel/$slug': typeof ArtikelSlugRoute
  '/shop/$slug': typeof ShopSlugRoute
  '/admin': typeof AdminIndexRoute
  '/artikel': typeof ArtikelIndexRoute
  '/jasa-cetak': typeof JasaCetakIndexRoute
  '/konversi-kti': typeof KonversiKtiIndexRoute
  '/penerbitan': typeof PenerbitanIndexRoute
  '/pra-cetak': typeof PraCetakIndexRoute
  '/shop': typeof ShopIndexRoute
  '/admin/products/create': typeof AdminProductsCreateRoute
  '/admin/products': typeof AdminProductsIndexRoute
  '/admin/products/$id/edit': typeof AdminProductsIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/kontak': typeof KontakRoute
  '/admin/login': typeof AdminLoginRoute
  '/artikel/$slug': typeof ArtikelSlugRoute
  '/shop/$slug': typeof ShopSlugRoute
  '/admin': typeof AdminIndexRoute
  '/artikel': typeof ArtikelIndexRoute
  '/jasa-cetak': typeof JasaCetakIndexRoute
  '/konversi-kti': typeof KonversiKtiIndexRoute
  '/penerbitan': typeof PenerbitanIndexRoute
  '/pra-cetak': typeof PraCetakIndexRoute
  '/shop': typeof ShopIndexRoute
  '/admin/products/create': typeof AdminProductsCreateRoute
  '/admin/products': typeof AdminProductsIndexRoute
  '/admin/products/$id/edit': typeof AdminProductsIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/kontak': typeof KontakRoute
  '/admin/login': typeof AdminLoginRoute
  '/artikel/$slug': typeof ArtikelSlugRoute
  '/shop/$slug': typeof ShopSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/artikel/': typeof ArtikelIndexRoute
  '/jasa-cetak/': typeof JasaCetakIndexRoute
  '/konversi-kti/': typeof KonversiKtiIndexRoute
  '/penerbitan/': typeof PenerbitanIndexRoute
  '/pra-cetak/': typeof PraCetakIndexRoute
  '/shop/': typeof ShopIndexRoute
  '/admin/products/create': typeof AdminProductsCreateRoute
  '/admin/products/': typeof AdminProductsIndexRoute
  '/admin/products/$id/edit': typeof AdminProductsIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/kontak'
    | '/admin/login'
    | '/artikel/$slug'
    | '/shop/$slug'
    | '/admin'
    | '/artikel'
    | '/jasa-cetak'
    | '/konversi-kti'
    | '/penerbitan'
    | '/pra-cetak'
    | '/shop'
    | '/admin/products/create'
    | '/admin/products'
    | '/admin/products/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/kontak'
    | '/admin/login'
    | '/artikel/$slug'
    | '/shop/$slug'
    | '/admin'
    | '/artikel'
    | '/jasa-cetak'
    | '/konversi-kti'
    | '/penerbitan'
    | '/pra-cetak'
    | '/shop'
    | '/admin/products/create'
    | '/admin/products'
    | '/admin/products/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/kontak'
    | '/admin/login'
    | '/artikel/$slug'
    | '/shop/$slug'
    | '/admin/'
    | '/artikel/'
    | '/jasa-cetak/'
    | '/konversi-kti/'
    | '/penerbitan/'
    | '/pra-cetak/'
    | '/shop/'
    | '/admin/products/create'
    | '/admin/products/'
    | '/admin/products/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  KontakRoute: typeof KontakRoute
  AdminLoginRoute: typeof AdminLoginRoute
  ArtikelSlugRoute: typeof ArtikelSlugRoute
  ShopSlugRoute: typeof ShopSlugRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ArtikelIndexRoute: typeof ArtikelIndexRoute
  JasaCetakIndexRoute: typeof JasaCetakIndexRoute
  KonversiKtiIndexRoute: typeof KonversiKtiIndexRoute
  PenerbitanIndexRoute: typeof PenerbitanIndexRoute
  PraCetakIndexRoute: typeof PraCetakIndexRoute
  ShopIndexRoute: typeof ShopIndexRoute
  AdminProductsCreateRoute: typeof AdminProductsCreateRoute
  AdminProductsIndexRoute: typeof AdminProductsIndexRoute
  AdminProductsIdEditRoute: typeof AdminProductsIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/kontak': {
      id: '/kontak'
      path: '/kontak'
      fullPath: '/kontak'
      preLoaderRoute: typeof KontakRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop/': {
      id: '/shop/'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof ShopIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pra-cetak/': {
      id: '/pra-cetak/'
      path: '/pra-cetak'
      fullPath: '/pra-cetak'
      preLoaderRoute: typeof PraCetakIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/penerbitan/': {
      id: '/penerbitan/'
      path: '/penerbitan'
      fullPath: '/penerbitan'
      preLoaderRoute: typeof PenerbitanIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/konversi-kti/': {
      id: '/konversi-kti/'
      path: '/konversi-kti'
      fullPath: '/konversi-kti'
      preLoaderRoute: typeof KonversiKtiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jasa-cetak/': {
      id: '/jasa-cetak/'
      path: '/jasa-cetak'
      fullPath: '/jasa-cetak'
      preLoaderRoute: typeof JasaCetakIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artikel/': {
      id: '/artikel/'
      path: '/artikel'
      fullPath: '/artikel'
      preLoaderRoute: typeof ArtikelIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop/$slug': {
      id: '/shop/$slug'
      path: '/shop/$slug'
      fullPath: '/shop/$slug'
      preLoaderRoute: typeof ShopSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artikel/$slug': {
      id: '/artikel/$slug'
      path: '/artikel/$slug'
      fullPath: '/artikel/$slug'
      preLoaderRoute: typeof ArtikelSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products/': {
      id: '/admin/products/'
      path: '/admin/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products/create': {
      id: '/admin/products/create'
      path: '/admin/products/create'
      fullPath: '/admin/products/create'
      preLoaderRoute: typeof AdminProductsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products/$id/edit': {
      id: '/admin/products/$id/edit'
      path: '/admin/products/$id/edit'
      fullPath: '/admin/products/$id/edit'
      preLoaderRoute: typeof AdminProductsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KontakRoute: KontakRoute,
  AdminLoginRoute: AdminLoginRoute,
  ArtikelSlugRoute: ArtikelSlugRoute,
  ShopSlugRoute: ShopSlugRoute,
  AdminIndexRoute: AdminIndexRoute,
  ArtikelIndexRoute: ArtikelIndexRoute,
  JasaCetakIndexRoute: JasaCetakIndexRoute,
  KonversiKtiIndexRoute: KonversiKtiIndexRoute,
  PenerbitanIndexRoute: PenerbitanIndexRoute,
  PraCetakIndexRoute: PraCetakIndexRoute,
  ShopIndexRoute: ShopIndexRoute,
  AdminProductsCreateRoute: AdminProductsCreateRoute,
  AdminProductsIndexRoute: AdminProductsIndexRoute,
  AdminProductsIdEditRoute: AdminProductsIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
